module.exports = __webpack_public_path__ + "static/media/bracket-center-02.9b1d1301.svg";